/**
 * جسر تنبيهات مؤجَّل — يمنع دخول مكتبة sonner في حزمة الإقلاع الأولى.
 * تُستخدم في المسارات الحرجة (AuthContext / Header) حيث التنبيه حدث لاحق
 * لا جزء من أوّل رسم. المكوّن <Toaster /> نفسه مُركَّب lazy في __root.tsx.
 */
type ToastOptions = Record<string, unknown>;

async function call(kind: "success" | "error" | "message", message: string, options?: ToastOptions) {
  const mod = await import("sonner");
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (mod.toast as any)[kind](message, options);
}

export const lazyToast = {
  success: (message: string, options?: ToastOptions) => {
    void call("success", message, options);
  },
  error: (message: string, options?: ToastOptions) => {
    void call("error", message, options);
  },
  message: (message: string, options?: ToastOptions) => {
    void call("message", message, options);
  },
};
